import { TaskData } from "@/core/types/types";

export interface ClaimCheckState {
  currentStep: TaskData | null;
  isLoading: boolean;
  error: Error | null;
  visitedSteps: string[];
}

export const initialState = {
  currentStep: null,
  isLoading: false,
  error: null,
  visitedSteps: [],
};

export enum ClaimCheckActionType {
  SetCurrentStep = "setCurrentStep",
  SetIsLoading = "setIsLoading",
  SetError = "setError",
  PushVisitedStep = "pushVisitedStep",
  PopVisitedStep = "popVisitedStep",
}

type SetCurrentStepAction = {
  type: ClaimCheckActionType.SetCurrentStep;
  payload: TaskData;
};

type SetIsLoadingAction = {
  type: ClaimCheckActionType.SetIsLoading;
  payload: boolean;
};

type SetErrorAction = {
  type: ClaimCheckActionType.SetError;
  payload: Error | null;
};

type PushVisitedStepAction = {
  type: ClaimCheckActionType.PushVisitedStep;
  payload: string | "next-step";
};

type PopVisitedStepAction = {
  type: ClaimCheckActionType.PopVisitedStep;
};

export type ClaimCheckAction =
  | SetCurrentStepAction
  | SetIsLoadingAction
  | SetErrorAction
  | PushVisitedStepAction
  | PopVisitedStepAction;

export const reducer = (
  state: ClaimCheckState,
  action: ClaimCheckAction
): ClaimCheckState => {
  switch (action.type) {
    case ClaimCheckActionType.SetCurrentStep:
      return { ...state, currentStep: action.payload };

    case ClaimCheckActionType.SetIsLoading:
      return { ...state, isLoading: action.payload };

    case ClaimCheckActionType.SetError:
      return { ...state, error: action.payload };

    case ClaimCheckActionType.PushVisitedStep:
      return {
        ...state,
        visitedSteps: [...state.visitedSteps, action.payload || ""],
      };

    case ClaimCheckActionType.PopVisitedStep:
      return {
        ...state,
        visitedSteps: state.visitedSteps.slice(0, -1),
      };

    default:
      return state;
  }
};
